import MyBread from '@/components/cuscom/myBread.vue';
import pagination from '@/components/cuscom/paging.vue';
import BtnGroup from '@/components/cuscom/btns-group.vue';
import datePicker from '@/components/cuscom/v-date-picker.vue';
import myInput from '@/my/input';
export default {
  vm: {},

  install(Vue) {
    //注册全局自定义组件
    Vue.component(MyBread.name, MyBread);
    Vue.component(pagination.name, pagination);
    Vue.component(BtnGroup.name, BtnGroup);
    Vue.component(datePicker.name, datePicker);
    Vue.component('myInput', myInput);
  }
};



// WEBPACK FOOTER //
// ./src/plugins/cus-component.js